module.exports = __webpack_public_path__ + "img/brand_6.4c921b7d.png";